var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form, Modal, message } from 'antd';
import { useTranslation } from 'react-i18next';
import Input from '@fp-suite/core-ui/src/components/Input';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
import { usePackingState } from '../hooks';
import { useContainerActions } from '../hooks/useContainerActions';
import { useWeightStationHeartbeat } from '../weight/useWeightStationHeartbeat';
import { WeightStationHeartbeatIndicator } from '../weight/WeightStationHeartbeatIndicator';
import { boxKindForContainerType, filterBoxTypesForContainer, isPalletContainerType } from '../shared/boxTypeFilters';
export var UpdateContainerModal = function (_a) {
    var visible = _a.visible, container = _a.container, onClose = _a.onClose, onUpdated = _a.onUpdated;
    var t = useTranslation().t;
    var form = Form.useForm()[0];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var _c = usePackingState(), shipmentId = _c.shipmentId, boxTypes = _c.boxTypes, loadBoxTypes = _c.loadBoxTypes, loadPackageWeight = _c.loadPackageWeight;
    var handleUpdateContainer = useContainerActions().handleUpdateContainer;
    var isConfirmLoading = isSubmitting;
    var filteredBoxTypes = useMemo(function () { return filterBoxTypesForContainer(boxTypes, boxKindForContainerType(container === null || container === void 0 ? void 0 : container.containerTypeEnumId)); }, [boxTypes, container === null || container === void 0 ? void 0 : container.containerTypeEnumId]);
    var isPallet = isPalletContainerType(container === null || container === void 0 ? void 0 : container.containerTypeEnumId);
    var _d = useWeightStationHeartbeat({
        enabled: visible && !isPallet,
        shipmentId: shipmentId,
        shipmentPackageSeqId: undefined,
        loadPackageWeight: loadPackageWeight,
        onWeightReceived: function (weight) {
            form.setFieldsValue({ weight: String(weight) });
        }
    }), lastWeightReceivedAt = _d.lastWeightReceivedAt, weightAgeSeconds = _d.weightAgeSeconds, weightPulseClass = _d.weightPulseClass, hasActiveSource = _d.hasActiveSource, isQzConnected = _d.isQzConnected;
    useEffect(function () {
        if (!visible || !container)
            return;
        form.setFieldsValue({
            shipmentBoxTypeId: container.shipmentBoxTypeId || undefined,
            weight: container.weight != null ? String(container.weight) : ''
        });
    }, [form, container, visible]);
    useEffect(function () {
        if (!visible)
            return;
        if (boxTypes.length === 0) {
            void loadBoxTypes();
        }
    }, [boxTypes.length, loadBoxTypes, visible]);
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var values, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!container || isConfirmLoading)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    setIsSubmitting(true);
                    return [4 /*yield*/, form.validateFields()];
                case 2:
                    values = _a.sent();
                    return [4 /*yield*/, handleUpdateContainer({
                            containerId: container.containerId,
                            shipmentBoxTypeId: values.shipmentBoxTypeId,
                            weight: parseFloat(values.weight),
                            weightUomId: 'WT_lb'
                        })];
                case 3:
                    _a.sent();
                    form.resetFields();
                    onUpdated();
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    if (error_1 === null || error_1 === void 0 ? void 0 : error_1.errorFields)
                        return [2 /*return*/];
                    message.error(t('Failed to update container'));
                    return [3 /*break*/, 6];
                case 5:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [form, handleUpdateContainer, isConfirmLoading, onUpdated, container, t]);
    return (_jsx(Modal, __assign({ title: container ? t('Update Container') + " #" + container.containerId : t('Update Container'), visible: visible, onCancel: function () {
            if (isConfirmLoading)
                return;
            onClose();
        }, onOk: handleSubmit, okText: t('Save'), confirmLoading: isConfirmLoading, cancelButtonProps: { disabled: isConfirmLoading }, maskClosable: !isConfirmLoading, keyboard: !isConfirmLoading }, { children: _jsxs(Form, __assign({ form: form, layout: 'vertical' }, { children: [_jsx(Form.Item, __assign({ name: 'shipmentBoxTypeId', label: t('Box Type'), rules: [{ required: true, message: t('Please select box type') }] }, { children: _jsx(Dropdown, { searchable: true, placeholder: t('Select Box Type'), data: filteredBoxTypes }, void 0) }), void 0), _jsx(Form.Item, __assign({ name: 'weight', label: t('Container Weight (lbs)'), rules: [
                        { required: true, message: t('Please enter container weight') },
                        { pattern: /^\d+(\.\d+)?$/, message: t('Enter a valid weight') }
                    ] }, { children: _jsx(Input, { title: '', inputType: 'number', placeholder: t('Scan weight'), autoFocus: true }, void 0) }), void 0), _jsx(WeightStationHeartbeatIndicator, { lastWeightReceivedAt: lastWeightReceivedAt, weightAgeSeconds: weightAgeSeconds, weightPulseClass: weightPulseClass, hasActiveSource: hasActiveSource, isQzConnected: isQzConnected }, void 0)] }), void 0) }), void 0));
};
export default UpdateContainerModal;
